import { root, id } from './update';

export const update = {
  ...root,
  id,
};
